import petProductService from 'bff/services/petProductService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import PetVaccineDatePicker from 'containers/InsureProcess/InsureProcseePet/PetVaccineDatePicker';
import { Gender, question, STEP, styles } from 'containers/InsureProcess/InsureProcseePet/types';
import { ErrorMessage, Field, Form, Formik, getIn } from 'formik';
import { AutoComplete, DatePicker } from 'formik-antd';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import sweetAlertService from 'utils/sweetAlertService';
import { Moment } from 'moment';
import InputWithRegex from 'components/InputWithRegex';
import { AgeData, EmailDomain, Occupation, OccupationContent, Postcode, SysOption } from 'bff/models/info';
import AddressComponent from 'components/AddressComponent';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import memberProfileService from 'bff/services/memberProfileService';
import { CodeId } from 'constants/enums/codeId.enum';
import * as Yup from 'yup';
import { emailRegex, mobileRegex } from 'utils/commonValidations';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { setRuleValidErrorModalVisible } from 'redux/actions/modal.action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import PetFormikFocusError from './PetFormikFocusError';

const initForm = {
  petGender: Gender.male,
  petWeight: 1,
  vaccineDate: '',
  noVaccine: false,
  petImage: '',
  // 要保人資料
  MEMBER_ID: '',
  NAME: '',
  BIRTHDAY: moment().format('1990/01/01'),
  MOBILE: '',
  EMAIL_ADDR: '',
  POST_CODE: '',
  CITY_ID: '',
  AREA_NAME: '',
  AREA_ID: '',
  ADDRESS: '',
  GENDER: '',
  OCCUPATION_DOMAIN_ID: '',
  OCCUPATION_DOMAIN_ID_NAME: '',
  OCCUPATION_ID: '',
  OCCUPATION_ID_NAME: '',
  KYC_DATA: [
    {
      KYC_ID: '',
      KYC_ANSWER: '',
      KYC_OTHER: ''
    }
  ],
  delivery: '1'
};

const validationSchema = Yup.object().shape({
  petWeight: Yup.number().required('此為必填欄位').min(1, '寵物重量應大於0').max(99, '寵物重量應小於100').integer('請輸入整數'),
  petImage: Yup.string().required('請上傳寵物照片'),
  MEMBER_ID: Yup.string().required('此為必填欄位').length(10, '帳號長度為 10 字元'),
  NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').max(200, '姓名長度不可超過 200 字元').test('contain num', '姓名格式不符', (val: string) => {
    if (val) {
      return !(/[\d]+/.test(val));
    }
    return true;
  }),
  BIRTHDAY: Yup.string().required('此為必填欄位').nullable(),
  EMAIL_ADDR: Yup.string().required('此為必填欄位').matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元'),
  POST_CODE: Yup.string().required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
  CITY_ID: Yup.string().required('此為必填欄位'),
  AREA_ID: Yup.string().required('此為必填欄位'),
  ADDRESS: Yup.string().required('此為必填欄位').max(200, '詳細地址長度不可超過 200 字元'),
  MOBILE: Yup.string().required('此為必填欄位').length(10, '手機號碼長度為 10 字元').test('mobile format', '手機格式不符', (val: string) => {
    if (val) {
      return mobileRegex.test(val);
    }
    return true;
  }),
  OCCUPATION_DOMAIN_ID: Yup.string().required('此為必填欄位').nullable(),
  OCCUPATION_ID: Yup.string().when('OCCUPATION_DOMAIN_ID', (occupationId: OccupationIdType, schema: any) => {
    return occupationId && occupationId === OccupationIdType.Special ? schema.required('職業項目為必填欄位') : schema;
  }).nullable(),
  KYC_DATA: Yup.array().of(
    Yup.object().shape({
      KYC_ID: Yup.string().required('此為必填欄位'),
      KYC_ANSWER: Yup.string().required('此為必填欄位'),
      KYC_OTHER: Yup.string().when('KYC_ANSWER', (kycAnswer: any, schema: any) => {
        return kycAnswer && kycAnswer === '99' ? schema.required('請輸入資金來源') : schema;
      })
    })
  )
});

function InsureProcessInformation (props: any) {
  const [state, setState] = useState({
    occupationId: '',
    memberIdErrMsg: '',
    hasMemberId: false,
    isAgeLimit: false,
    birthdayErrMsg: '',
    hidePolicyID: false
  });
  // UI variable
  const insureDelivery = props.sysOption ? props.sysOption.PODELIVERY.filter((sysopt: SysOption) => sysopt.PARAM_VALUE === PolicyDelivery.Electric)[0] : { PARAM_VALUE: '', PARAM_TEXT: '' };

  let occupationIdOpt: JSX.Element[];
  if (props.state.occupations && props.state.occupations.length > 0) {
    occupationIdOpt = props.state.occupations.map((occupation: Occupation, index: number) => {
      return <option key={index} value={occupation.OCCUPATION_DOMAIN_ID}>{occupation.OCCUPATION_NAME}</option>;
    });
  }

  let occupationContents: JSX.Element[];
  if (state.occupationId && (state.occupationId === OccupationIdType.Special || state.occupationId === OccupationIdType.Normal)) {
    const occupation = props.state.occupations.find((occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === state.occupationId);

    if (occupation) {
      occupationContents = occupation.OCCUPATION.map((content: OccupationContent, index: number) => {
        return <option key={index} value={content.OCCUPATION_ID}>{content.OCCUPATION_NAME}</option>;
      });
    }
  }

  const uploadPetImage = async (data: any) => {
    const req = {
      APPLY_NO: props.state.applyNo,
      PET_CHIP: props.state.petChip,
      IMAGE_B64: data
    };
    const res = await petProductService.uploadPetImg(req);
    if (!res) return;

    props.setState((prev: any) => ({
      ...prev,
      petPic: res.TRANRS.PET_PIC
    }));

    const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
    const tempData = {
      ...originTempData,
      petPic: res.TRANRS.PET_PIC
    };
    commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
    return res;
  };

  const handleOccupationIdChange = (e: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
    commonService.setSelectOptName(setFieldValue, 'OCCUPATION_DOMAIN_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);

    setState(prev => ({
      ...prev,
      occupationId: e.currentTarget.value
    }));

    if (!e.target.value || e.currentTarget.value === OccupationIdType.Special) {
      setFieldValue('OCCUPATION_ID', '');
      setFieldValue('OCCUPATION_ID_NAME', '');
    }

    if (e.target.value === OccupationIdType.Normal) {
      const occupation =
        props.state.occupations.find((occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === e.target.value);
      if (!occupation) return;

      setFieldValue('OCCUPATION_ID', occupation.OCCUPATION[0].OCCUPATION_ID);
      setFieldValue('OCCUPATION_ID_NAME', '');
    }
  };

  /** 檢核身分證 */
  const onValidID = async (val: string, nationalityType: string) => {
    if (state.hasMemberId || !props.informationFormRef || !props.informationFormRef.current) return;
    if (val && val.length === 10) {
      const errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);
      props.informationFormRef.current.setFieldError('MEMBER_ID', errorVal);
      setState(prev => ({
        ...prev,
        memberIdErrMsg: errorVal
      }));
    }
  };

  /** 檢核生日 */
  const handleValidBirthday = async (val: any, formVal: any) => {
    if (!val) return;

    const age = await handleGetInsuredAge(val);

    // < 7 歲，則提示訊息：親愛的客戶您好，要保人須年滿7歲，不得繼續。
    if (age < 7) {
      handleShowErrorMsg(CodeId.W003);
      setState(prev => ({
        ...prev,
        isAgeLimit: true
      }));
      setState(prev => ({
        ...prev,
        birthdayErrMsg: '要保人須年滿7歲'
      }));
      props.informationFormRef.current.setFieldError('BIRTHDAY', '要保人須年滿7歲');
      props.informationFormRef.current.setFieldTouched('BIRTHDAY', true);
      return;
    }

    // > 7 且 <= 17 歲，則提示訊息：親愛的客戶您好，要保人未滿18歲，投保時要保書須法定代理人簽名，僅提示可繼續投保。
    if (age <= 17) {
      handleShowErrorMsg(CodeId.W004);
    }

    // 若 通過檢核 且 為年齡限制，設限制為 false
    if (state.isAgeLimit) {
      setState(prev => ({
        ...prev,
        isAgeLimit: false
      }));
    }

    setState(prev => ({
      ...prev,
      birthdayErrMsg: ''
    }));
    props.informationFormRef.current.setFieldError('BIRTHDAY', '');
    props.informationFormRef.current.setFieldTouched('BIRTHDAY', true);
  };

  /**
     * @description 顯示檢核錯誤訊息
    */
  const handleShowErrorMsg = (codeId: string) => {
    // 顯示錯誤訊息
    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: commonService.getCodeMsg(props.apiInfo.UICode, codeId)
    });
  };

  const handleGetInsuredAge = async (birthday: string) => {
    const startDate = props.state.startDate; // this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal.INSURED_RANGE;

    const ageData: AgeData = {
      CONTRACT_DATE: moment(startDate).format('YYYYMMDD'),
      BIRTHDAY: moment(birthday).format('YYYYMMDD')
    };

    const res = await memberProfileService.validContractAge([ageData]);
    if (!res) return 0;

    return res[0].CONTRACT_AGE as number;
  };

  const handleOnSubmit = async (val: any) => {
    console.log('🚀 ~ step2 val:', val);

    let vaccineDate = moment(val.vaccineDate, 'YYYY/MM/DD').format('YYYYMMDD');

    if (val.noVaccine) vaccineDate = '00000000';
    if (vaccineDate === 'Invaild Date') vaccineDate = props.state.vaccineDate;

    const req = {
      RULECHECK: {
        INS_TYPE_ID: props.state.insTypeId,
        PROD_ID: props.state.prodId,
        BC_TYPE: 'C',
        APPLY_NO: props.state.applyNo,
        // MEMBER_ID: 'T208455382',
        MEMBER_ID: storageService.getItem(storageKeys.MemberId),
        SPI_ATTACH: '0',
        PET_CHIP: props.state.petChip,
        PET_NAME: props.state.petName,
        PET_KIND: props.state.petKind,
        PET_SEX: val.petGender,
        PET_BDAY: moment(props.state.petBDay).format('YYYYMMDD'),
        PET_VAR_NO: props.state.petVarNo,
        PET_VAR_NAME: props.state.petVarName,
        PET_STERIL: props.state.petSteril,
        PET_VACCINATION: vaccineDate,
        START_DATE: moment(props.state.startDate, moment.ISO_8601).format('YYYYMMDD'),
        INSURED_DATA: {
          ROLE_TYPE: RuleCheckInsuredType.Applicant,
          ID: val.MEMBER_ID,
          ID_TYPE: 'N',
          NAME: val.NAME,
          BIRTHDAY: moment(val.BIRTHDAY, 'YYYY/MM/DD').format('YYYYMMDD'),
          NATIVE_ID: 'TW',
          OCP_TYPE: val.OCCUPATION_DOMAIN_ID === OccupationIdType.Normal ? OccupationIdType.RuleCheckNormal : OccupationIdType.Special ? OccupationIdType.RuleCheckSpecial : '',
          FEE: props.state.selectedCalcPlan.PREMIUM,
          MAIL: val.EMAIL_ADDR,
          MOBILE: val.MOBILE
        },
        KYC_DATA: val.KYC_DATA
      },
      CHECK_TYPE: 'V',
      AGREE_TIME_TERMS: props.state.ALL_CONTRACT_CHECKED_TIME
    };

    const res = await petProductService.validPetInsRule(req);

    if (!res) return;

    // 檢核未通過
    if (res.TRANRS.ERROR_MSG?.length > 0) {
      props.setRuleValidErrorModalVisible(true, res.TRANRS.ERROR_MSG);
      return;
    }

    // 如果檢核通過
    props.setState((prev: any) => ({
      ...prev,
      validReq: req,
      petWeight: val.petWeight,
      POST_CODE: val.POST_CODE,
      CITY_ID: val.CITY_ID,
      AREA_ID: val.AREA_ID,
      ADDRESS: val.ADDRESS,
      delivery: val.delivery,
      OCCUPATION_ID: val.OCCUPATION_ID,
      OCCUPATION_ID_NAME: val.OCCUPATION_ID_NAME,
      OCCUPATION_DOMAIN_ID: val.OCCUPATION_DOMAIN_ID,
      OCCUPATION_DOMAIN_ID_NAME: val.OCCUPATION_DOMAIN_ID_NAME,
      GENDER: val.GENDER
    }));
    // 將通過檢核的資料放入暫存
    const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
    const tempData = {
      ...originTempData,
      validReq: req
    };
    commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
    props.handleStep(STEP.infoCheck);
  };

  const setMemberData = async () => {
    const memberProfile = await memberProfileService.fetchMemberProfile(storageService.getItem(storageKeys.MemberId));
    const setFieldValue = props.informationFormRef.current.setFieldValue;
    await setFieldValue('MEMBER_ID', memberProfile?.MEMBER_ID || '');
    await setFieldValue('NAME', memberProfile?.NAME || '');
    await setFieldValue('BIRTHDAY', memberProfile?.BIRTHDAY || '');
    await setFieldValue('MOBILE', memberProfile?.MOBILE || '');
    await setFieldValue('EMAIL_ADDR', memberProfile?.EMAIL_ADDR || '');
    await setFieldValue('POST_CODE', memberProfile?.POST_CODE || '');
    await setFieldValue('CITY_ID', memberProfile?.CITY_ID || '');
    await setFieldValue('AREA_NAME', memberProfile?.AREA_NAME || '');
    await setFieldValue('AREA_ID', memberProfile?.AREA_ID || '');
    await setFieldValue('ADDRESS', memberProfile?.ADDRESS || '');
    await setFieldValue('GENDER', memberProfile?.GENDER || '');
    setState(prev => ({ ...prev, hidePolicyID: true }));
  };

  const setTempFieldValue = async (tempData: any, setFieldValue: any) => {
    await setFieldValue('petGender', tempData.petGender || Gender.male, true);
    await setFieldValue('petWeight', tempData.petWeight || 1, true);
    if (tempData.vaccineDate) {
      await setFieldValue('vaccineDate', tempData.vaccineDate || '', true);
    } else {
      await setFieldValue('noVaccine', true, true);
    }
    await setFieldValue('petImage', tempData.petImage || '', true);
    await setFieldValue('OCCUPATION_DOMAIN_ID', tempData.OCCUPATION_DOMAIN_ID || '', true);
    await setFieldValue('OCCUPATION_DOMAIN_ID_NAME', tempData.OCCUPATION_DOMAIN_ID_NAME || '', true);
    await setFieldValue('OCCUPATION_ID', tempData.OCCUPATION_ID || '', true);
    await setFieldValue('OCCUPATION_ID_NAME', tempData.OCCUPATION_ID_NAME || '', true);
    await setFieldValue('KYC_DATA', tempData.KYC_DATA || [
      {
        KYC_ID: '',
        KYC_ANSWER: '',
        KYC_OTHER: ''
      }
    ], true);
    await setFieldValue('delivery', tempData.delivery || '1', true);
  };

  const compressImage = (image: any, imageType: any) => {
    return new Promise((resolve) => {
      const imageElement = new Image();
      const canvas = document.createElement('canvas');
      imageElement.onload = () => {
        const scale = imageElement.naturalWidth < imageElement.naturalHeight ? imageElement.naturalWidth / 250 : imageElement.naturalHeight / 250;
        canvas.width = Math.round(imageElement.naturalWidth / scale);
        canvas.height = Math.round(imageElement.naturalHeight / scale);
        const ctx = canvas.getContext('2d');
        if (ctx) ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
        const newImage = canvas.toDataURL(imageType, 1);
        resolve(newImage);
      };
      imageElement.src = image;
    });
  };

  const handleViewToggle = () => {
    setState(prev => ({ ...prev, hidePolicyID: !state.hidePolicyID }));
  };

  useEffect(() => {
    setMemberData();
    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)) ? JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)).tempInformationForm : null;
    if (tempData && props.informationFormRef.current) {
      setTempFieldValue(tempData, props.informationFormRef.current.setFieldValue);
    }
    return () => {
      const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
      const tempData = {
        ...originTempData,
        tempInformationForm: props.informationFormRef.current.values
      };
      commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
    };
  }, []);

  useEffect(() => {
    if (props.state.occupations) {
      setState((prev: any) => ({
        ...prev,
        occupationId: initForm.OCCUPATION_DOMAIN_ID
      }));
    }
  }, [props.state]);

  return (
    <div className="insure-process--travel">
      <div className="insure-process-building-info insure-process-fill" style={props.activeStep === STEP.infoFill ? undefined : styles.inline}>
        <Formik
          innerRef={props.informationFormRef}
          initialValues={initForm}
          validationSchema={validationSchema}
          onSubmit={(val: any) => {
            handleOnSubmit(val);
          }}
        >
          {({ values, errors, touched, handleBlur, handleChange, setFieldValue, setFieldTouched }) => (
            <Form noValidate>
              <div className="insure-process-building-info__content">
                <div className="building-info">
                  <div className="building-info__title">寵物詳細資料</div>
                  <div className="building-info__content">
                    {/* petGender */}
                    <div className="building-info__row">
                      <div id="insure-type-form-group" className="element__form-group">
                        <div className="element__form-group-title">寵物性別</div>
                        <div className="element__form-group-content">
                          <div className="element__radio-group">
                            <label>
                              <div className="element__radio">
                                <Field
                                  type="radio"
                                  name="petGender"
                                  value={Gender.male}
                                  onChange={handleChange}
                                  disabled
                                />
                                <div className="element__radio-btn" />
                              </div>
                              <span>公</span>
                            </label>
                          </div>
                          <div className="element__radio-group">
                            <label>
                              <div className="element__radio">
                                <Field
                                  type="radio"
                                  name="petGender"
                                  value={Gender.female}
                                  disabled
                                />
                                <div className="element__radio-btn" />
                              </div>
                              <span>母</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* vaccineDate */}
                    <div className="building-info__row">
                      <div className={'element__form-group' + (errors.vaccineDate && touched.vaccineDate ? ' element__form-group--invalid' : '')} id="insured-date-form-group">
                        <div className="element__form-group-title">狂犬病疫苗施打日期*</div>
                        <div className="element__form-group-content">
                          <PetVaccineDatePicker name="vaccineDate" />
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="vaccineDate" />
                        </div>
                      </div>
                      {/* 未施打狂犬病疫苗 */}
                      <div className="element__checkbox-group">
                        <label htmlFor="noVaccine">
                          <div className="element__checkbox">
                            <Field
                              type="checkbox"
                              name="noVaccine"
                              id="noVaccine"
                              disabled
                            />
                            <div className="element__checkbox-btn" />
                          </div>
                          <span>未施打狂犬病疫苗</span>
                        </label>
                      </div>
                    </div>
                    {/* petWeight */}
                    <div className="building-info__row">
                      <div className={'element__form-group' + (errors.petWeight && touched.petWeight ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">寵物體重(KG)</div>
                        <div className="element__form-group-content">
                          <div>
                            <Field
                              type="number"
                              name="petWeight"
                              min={1}
                              max={99}
                              className="element__input"
                              data-fieldname="petWeight"
                            />
                          </div>
                          <span className="pet-weight-span">體重需為整數</span>
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="petWeight" />
                        </div>
                      </div>
                    </div>
                    {/* petPics */}
                    <div className="building-info__row">
                      <div className={'element__form-group' + (errors.petImage && touched.petImage ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">寵物照片</div>
                        <div className="pet-image-info">
                          <span>三日內彩色正面照(含四肢)</span>
                          <span>照片規格限定JPG、PNG格式，大小不得超過2MB</span>
                        </div>
                        <div className="element__form-group-content">
                          <div className="correction__upload-field">
                            <div className="pet-image-row">
                              <div className="image-preview-container">
                                {values.petImage !== ''
                                  ? <img src={values.petImage} alt="petImage" className="image-preview" />
                                  : <div className="empty" />}
                              </div>
                              <label>
                                <div className="claim-service__upload-btn">上傳</div>
                                <input
                                  type="file"
                                  id="petImage"
                                  accept="image/jpg, image/jpeg, image/png"
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    // console.log("🚀 ~ e.currentTarget.files:", e.currentTarget.files)
                                    if (!e.currentTarget.files || e.currentTarget.files.length === 0) return;
                                    const file = e.currentTarget.files![0];
                                    const maxSize = 4 * 1024 * 1024;
                                    if (file.size > maxSize) {
                                      sweetAlertService.modal({
                                        icon: SweetAlertIcon.Info,
                                        html: '圖片大小不能超過 2 MB'
                                      });
                                      return;
                                    }
                                    return new Promise((resolve, reject) => {
                                      const reader = new FileReader();
                                      reader.onload = () => { resolve(reader.result); };
                                      reader.onerror = () => { reject(reader.error); };
                                      reader.readAsDataURL(file);
                                    }).then(async (result) => {
                                      const uploadRes = await uploadPetImage(result);
                                      if (uploadRes) {
                                        const compressedImage = await compressImage(result, file.type);
                                        // console.log(Math.round((compressedImage.length - 'data:image/png;base64,'.length) * 3 / 4), compressedImage);
                                        setFieldValue('petImage', compressedImage);
                                      };
                                    });
                                  }}
                                  data-fieldname="petImage"
                                />
                              </label>
                              {/* 上傳直接放入後端，無法清除 */}
                              {/* {values.petImage && <div className="claim-service__upload-btn" onClick={() => setFieldValue('petImage', '')}>清除</div>} */}
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name="petImage" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="insure-process-fill__content">
                {/* 要保人資料 */}
                <div className="policyholder-info">
                  <div className="policyholder-info__title">
                    <span style={{ color: '#000', marginLeft: 0 }}>要保人資料</span>
                    {/* <p>*完成投保後同步更新會員資料</p> */}
                  </div>
                  <div className="policyholder-info__content">
                    <div className="policyholder-info__form">
                      <div className="element__form-table">
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.MEMBER_ID && touched.MEMBER_ID ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">身分證字號</div>
                              {state.hidePolicyID
                                ? <input type="text" className="element__input" value={commonService.hiddenStringLastCharacter(values.MEMBER_ID, 5)} disabled readOnly />
                                : (
                                  <Field
                                    type="text"
                                    name="MEMBER_ID"
                                    maxLength={10}
                                    className="element__input"
                                    autoComplete="off"
                                    placeholder="請輸入身分證字號"
                                    validate={() => state.memberIdErrMsg}
                                    onChange={(e: any) => {
                                      const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                                      onValidID(val, 'N');
                                      setFieldTouched('MEMBER_ID', true);
                                      handleChange('MEMBER_ID')(e);
                                      setFieldValue('MEMBER_ID', val);
                                    }}
                                    disabled
                                  // onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  // }}
                                  // onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  // }}
                                  />
                                )}
                              <button type="button" className="element__view-btn" onClick={handleViewToggle}>
                                {state.hidePolicyID ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                              </button>
                              <div className="element__error-message">
                                <ErrorMessage name="MEMBER_ID" />
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-td" style={{ paddingBottom: 0 }}>
                            <div className={'element__form-group' + (errors.NAME && touched.NAME ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">要保人姓名*</div>
                              <Field
                                type="text"
                                name="NAME"
                                autoComplete="off"
                                maxLength={50}
                                className="element__input"
                                disabled
                              // onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                              // }}
                              />
                              <div className="element__error-message">
                                <ErrorMessage name="NAME" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.BIRTHDAY && touched.BIRTHDAY ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">生日* <span className="ant-picker-exam-info">範例： 20200101</span></div>
                              <div className="element__form-group-content">
                                <DatePicker
                                  name="BIRTHDAY"
                                  className="element__input"
                                  format="YYYYMMDD"
                                  showToday={false}
                                  validate={() => state.birthdayErrMsg}
                                  // defaultPickerValue={this.validBirthDay}
                                  disabledDate={(current: Moment) => {
                                    return current && (current > moment().add(-1, 'days') || current < moment('1911/01/01'));
                                  }}
                                  defaultPickerValue={moment('1990/01/01')}
                                  onChange={async (e) => {
                                    await handleValidBirthday(e, values);
                                  }}
                                  disabled
                                />
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="BIRTHDAY" />
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.MOBILE && touched.MOBILE ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">手機號碼*</div>
                              <Field
                                component={InputWithRegex}
                                name="MOBILE"
                                data-fieldname="MOBILE"
                                // tabIndex={5}
                                autoComplete="off"
                                className="element__input"
                                placeholder="0910123456"
                                maxLength={10}
                                disabled
                              // onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                              // }}
                              />
                              <div className="element__error-message">
                                <ErrorMessage name="MOBILE" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.EMAIL_ADDR && touched.EMAIL_ADDR ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">電子信箱*</div>
                              <AutoComplete
                                name="EMAIL_ADDR"
                                style={{ outline: 'none' }}
                                id="email"
                                className="element__antd-input"
                                placeholder="請輸入電子信箱"
                                options={
                                  (values.EMAIL_ADDR && !values.EMAIL_ADDR.includes('@') && props.apiInfo)
                                    ? props.apiInfo.emailDomains.map((item: EmailDomain) => ({ value: `${values.EMAIL_ADDR}@${item.EMAIL_DOMAIN_NAME}` }))
                                    : undefined
                                }
                                disabled
                              // onBlur={(e: any) => {
                              // }}
                              />
                              <div className="element__error-message">
                                <ErrorMessage name="EMAIL_ADDR" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td w-100">
                            <div className={'element__form-group' + ((errors.POST_CODE && touched.POST_CODE) || (errors.ADDRESS && touched.ADDRESS) || (errors.CITY_ID && touched.CITY_ID) || (errors.AREA_ID && touched.AREA_ID) ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">通訊地址*</div>
                              <div className="element__form-group-content" style={{ flexWrap: 'wrap' }}>
                                <AddressComponent
                                  postCodeName="POST_CODE"
                                  postCodeId="postal-code-input"
                                  postCodeIdTabIndex={7}
                                  cityIdName="CITY_ID"
                                  cityId="county-select"
                                  cityIdVal={values.CITY_ID}
                                  cityIdText="CITY_NAME"
                                  cityIdTabIndex={8}
                                  areaIdName="AREA_ID"
                                  areaId="district-select"
                                  areaIdTabIndex={9}
                                  areaNameVal={values.AREA_NAME}
                                  areaIdText="AREA_NAME"
                                  addressName="ADDRESS"
                                  addressId="address-input-pet"
                                  addressIdTabIndex={10}
                                  postcodes={props.apiInfo ? props.apiInfo.postcodes as Postcode[] : []}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  setFieldValue={setFieldValue}
                                  disabled
                                />
                              </div>
                              <div className="element__error-message">
                                {
                                  errors.POST_CODE
                                    ? <ErrorMessage name="POST_CODE" />
                                    : errors.CITY_ID
                                      ? <ErrorMessage name="CITY_ID" />
                                      : errors.AREA_ID
                                        ? <ErrorMessage name="AREA_ID" />
                                        : errors.ADDRESS
                                          ? <ErrorMessage name="ADDRESS" />
                                          : ''
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td w-50">
                            <div className={'element__form-group' + ((errors.OCCUPATION_DOMAIN_ID && touched.OCCUPATION_DOMAIN_ID) || (errors.OCCUPATION_ID && touched.OCCUPATION_ID) ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">職業類別*</div>
                              <div className="element__form-group-content">
                                <Field
                                  as="select"
                                  name="OCCUPATION_DOMAIN_ID"
                                  data-fieldname="OCCUPATION_DOMAIN_ID"
                                  tabIndex={11}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    handleOccupationIdChange(e, setFieldValue);
                                    handleChange('OCCUPATION_DOMAIN_ID')(e);
                                  }}
                                  id="career-category-select"
                                  className="element__select"
                                >
                                  <option value="">請選擇</option>
                                  {occupationIdOpt}
                                </Field>
                                <Field
                                  as="select"
                                  name="OCCUPATION_ID"
                                  data-fieldname="OCCUPATION_ID"
                                  tabIndex={12}
                                  id="career-items-select"
                                  className="element__select"
                                  disabled={values.OCCUPATION_DOMAIN_ID !== OccupationIdType.Special}
                                  onChange={(e: any) => {
                                    commonService.setSelectOptName(setFieldValue, 'OCCUPATION_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                    handleChange('OCCUPATION_ID')(e);
                                  }}
                                >
                                  <option value="">請選擇</option>
                                  {occupationContents}
                                </Field>
                              </div>
                              <div className="element__error-message">
                                {
                                  errors.OCCUPATION_DOMAIN_ID
                                    ? <ErrorMessage name="OCCUPATION_DOMAIN_ID" />
                                    : errors.OCCUPATION_ID
                                      ? <ErrorMessage name="OCCUPATION_ID" />
                                      : ''
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td w-100">
                            <div className="statement__content">
                              <div className="statement__form" style={{ outline: 'none' }}>
                                {props.formField.fundSource.map((fundSource: question, index: number) => (
                                  <div
                                    className={'element__form-group' + (
                                      (getIn(errors, `KYC_DATA[${index}].KYC_ANSWER`) && getIn(touched, `KYC_DATA[${index}].KYC_ANSWER`)) || (getIn(errors, `KYC_DATA[${index}].KYC_OTHER`) && getIn(touched, `KYC_DATA[${index}].KYC_OTHER`))
                                        ? ' element__form-group--invalid'
                                        : '')} key={fundSource.KYC_ID}
                                  >
                                    <div className="element__form-group-title">{fundSource.KYC_SUBJECT}</div>
                                    <div className="element__form-group-content">
                                      {fundSource.KYC_OPTIONS.map((opt: any) => (
                                        <div key={fundSource.KYC_ID + opt.KEY} className="element__radio-group">
                                          <label htmlFor={`KYC_DATA-${opt.KEY}`}>
                                            <div className="element__radio">
                                              <Field
                                                type="radio"
                                                name={`KYC_DATA[${index}].KYC_ANSWER`}
                                                id={`KYC_DATA-${opt.KEY}`}
                                                value={opt.KEY}
                                                onClick={(e: any) => {
                                                  if (e.currentTarget.value !== '99' && getIn(values, `KYC_DATA[${index}].KYC_OTHER`)) {
                                                    setFieldValue(`KYC_DATA[${index}].KYC_OTHER`, '', false);
                                                  }
                                                  setFieldValue(`KYC_DATA[${index}].KYC_ANSWER`, opt.KEY);
                                                  setFieldValue(`KYC_DATA[${index}].KYC_ID`, fundSource.KYC_ID);
                                                }}
                                                data-fieldname="KYC_DATA"
                                              />
                                              <div className="element__radio-btn" />
                                            </div>
                                            <span>{opt.VAL}</span>
                                          </label>
                                          {
                                            opt.KEY === '99'
                                              ? (
                                                <Field
                                                  maxLength={50}
                                                  autoComplete="off"
                                                  disabled={getIn(values, `KYC_DATA[${index}].KYC_ANSWER`) !== '99'}
                                                  type="text"
                                                  name={`KYC_DATA[${index}].KYC_OTHER`}
                                                  id={`KYC_DATA-${index}-input`}
                                                  className="element__input"
                                                  placeholder="請輸入資金來源"
                                                />
                                              )
                                              : null
                                          }
                                        </div>
                                      ))}
                                    </div>
                                    <div className="element__error-message">
                                      <ErrorMessage name={`KYC_DATA[${index}].KYC_ANSWER`} />
                                      <ErrorMessage name={`KYC_DATA[${index}].KYC_OTHER`} />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="delivery">
                  <div className="delivery__title">保單寄送方式</div>
                  <div className="delivery__content">
                    <div className="element__form-group">
                      {/* <div className={'element__form-group' + (errors.DELIVERY && touched.DELIVERY ? ' element__form-group--invalid' : '')}> */}
                      <div className="element__form-group-content">
                        <div className="element__radio-group">
                          <label htmlFor="electronic-delivery-radio">
                            <div className="element__radio">
                              <Field
                                type="radio"
                                name="DELIVERY"
                                id="electronic-delivery-radio"
                                value={insureDelivery.PARAM_VALUE}
                                checked
                              />
                              <div className="element__radio-btn" />
                            </div>
                            <span>{insureDelivery.PARAM_TEXT}</span>
                          </label>
                          {
                            insureDelivery.PARAM_VALUE === PolicyDelivery.Electric ? <a className="element__link" href={RouterSettings.MemberCenter.ElectronicPolicy} rel="noopener noreferrer" target="_blank">(說明)</a> : null
                          }
                        </div>
                      </div>
                      <div className="element__error-message">
                        <ErrorMessage name="DELIVERY" className="element__error-message" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* form1 submit */}
              <div className="insure-process-building-info__controls pet-controls">
                <button type="button" className="element__button element__button--red-border" onClick={() => props.handleStep(STEP.calcBill)}>返回上一頁</button>
                <button type="submit" className="element__button element__button--red">下一步</button>
              </div>
              <PetFormikFocusError />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: any[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs))
  };
};

export default connect(null, mapDisatchToProps)(InsureProcessInformation);
